// OUR MODULES
import RequestRabbit from './RequestRabbit';

// CONFIGURATION
import config from '../Config';

const useRouteRequest = () => {
  const searchRoutes = async (data, errorHandler) => {
    try {
      const params = new URLSearchParams(data);
      const url = `${config.baseServerURL}/admin/route?${params.toString()}`;
      const headers = new Headers({ 'Content-Type': 'application/json' });
      const options = {
        method: 'GET',
        headers: headers,
      };
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();
      return responseJSON;
    } catch (error) {
      errorHandler(error);
    }
  };

  const getRoute = async (routeId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/route/${routeId}`;
      const options = {
        method: 'GET',
      };
      const response = await RequestRabbit.request(url, options, errorHandler);
      return await response?.json();
    } catch (error) {
      errorHandler(error);
    }
  };

  const createRoute = async (data, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/route`;
      const headers = new Headers({ 'Content-Type': 'application/json' });
      const options = {
        method: 'POST',
        body: JSON.stringify(data) || null,
        headers: headers,
      };
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();
      return responseJSON;
    } catch (error) {
      errorHandler(error);
    }
  };

  const updateRoute = async (routeId, data, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/route/${routeId}`;
      const headers = new Headers({ 'Content-Type': 'application/json' });
      const options = {
        method: 'PUT',
        body: JSON.stringify(data) || null,
        headers: headers,
      };
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();
      return responseJSON;
    } catch (error) {
      errorHandler(error);
    }
  };

  const deleteRoute = async (routeId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/route/${routeId}`;
      const options = {
        method: 'DELETE',
      };
      await RequestRabbit.request(url, options, errorHandler);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getCarriersByRoute = async (routeId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/route/${routeId}/carriers`;
      const options = {
        method: 'GET',
      };
      const response = await RequestRabbit.request(url, options, errorHandler);
      return await response?.json();
    } catch (error) {
      errorHandler(error);
    }
  };

  const getCarriers = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/route/carriers`;
      const options = {
        method: 'GET',
      };
      const response = await RequestRabbit.request(url, options, errorHandler);
      return await response?.json();
    } catch (error) {
      errorHandler(error);
    }
  };

  const createCarrier = async (data, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/route/carriers`;
      const headers = new Headers({ 'Content-Type': 'application/json' });
      const options = {
        method: 'POST',
        body: JSON.stringify(data) || null,
        headers: headers,
      };
      await RequestRabbit.request(url, options, errorHandler);
    } catch (error) {
      errorHandler(error);
    }
  };

  const updateCarrier = async (data, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/route/carriers/${data.carrier_route_id}`;
      const headers = new Headers({ 'Content-Type': 'application/json' });
      const options = {
        method: 'PUT',
        body: JSON.stringify(data) || null,
        headers: headers,
      };
      await RequestRabbit.request(url, options, errorHandler);
    } catch (error) {
      errorHandler(error);
    }
  };

  const deleteCarrier = async (carrierRouteId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/route/carriers/${carrierRouteId}`;
      const options = {
        method: 'DELETE',
      };
      await RequestRabbit.request(url, options, errorHandler);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getOptions = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/route/options`;
      const options = {
        method: 'GET',
      };
      const response = await RequestRabbit.request(url, options, errorHandler);
      return await response?.json();
    } catch (error) {
      errorHandler(error);
    }
  };

  return {
    createCarrier,
    createRoute,
    getCarriers,
    getCarriersByRoute,
    getOptions,
    getRoute,
    updateCarrier,
    updateRoute,
    deleteCarrier,
    deleteRoute,
    searchRoutes,
  };
};

export default useRouteRequest;
